<template>
    <v-card @click.native="$emit('click')" flat class="soli-round w-full">
        <v-container>
            <div class="!flex flex-row">
                <div>
                    <v-list-item-avatar :size="64" class="mb-auto mt-0 pt-1">
                        <v-img :src="teacher.profile_photo_url" />
                    </v-list-item-avatar>
                </div>
                <div class="!flex flex-col justify-start w-full">
                    <v-list-item-title
                        class="font-bold justify-start w-full flex"
                    >
                        {{ teacher.name }}
                        <small
                            v-if="teacher.bio"
                            class="primary--text flex align-center px-2 underline caption cursor-pointer"
                            @click="dialog = true"
                            >More Info</small
                        >
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ teacher.instruments.map((i) => i.name).join(", ") }}
                    </v-list-item-subtitle>
                    <SoliTeacherCert
                        v-if="teacher.certification_level"
                        :teacher="teacher"
                    />
                    <div
                        v-if="hasOpenTimes"
                        class="staff-interval-listing mt-3 tracking-wide cursor-text select-text"
                        @click.stop=""
                    >
                        <div
                            v-for="(group, idx) in groupedIntervals"
                            :key="group.location || idx"
                            :class="{ 'mt-2': idx > 0 }"
                        >
                            <div
                                v-if="group.location"
                                class="caption font-weight-bold dim--text"
                            >
                                {{ group.location }}
                            </div>
                            <div>{{ group.times }}</div>
                        </div>
                    </div>
                    <div v-if="!hasOpenTimes && !loading">
                        Sorry, no times are available for this selection
                    </div>
                </div>
            </div>

            <TeacherInfo
                v-model="dialog"
                :teacher="teacher"
                :selectedInstrument="selectedInstrument"
                @close="dialog = false"
            ></TeacherInfo>
        </v-container>
    </v-card>
</template>

<script>
import TeacherInfo from "../Teachers/TeacherInfo.vue";

export default {
    components: {
        TeacherInfo,
    },
    props: {
        teacher: {
            type: Object,
            default: () => ({}),
        },
        selectedInstrument: {
            type: Number,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        intervalGroup: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
    computed: {
        hasOpenTimes() {
            return this.intervalGroup.some((e) => e.openTimes.length);
        },
        groupedIntervals() {
            if (!this.intervalGroup) return [];

            const groups = new Map();

            this.intervalGroup.forEach((interval) => {
                if (!interval.openTimes?.length) return;

                const location = interval.location ?? null;
                const formattedTimes = interval.openTimes.map((t) =>
                    t.replaceAll(" ", "").toLowerCase()
                );

                if (!groups.has(location)) {
                    groups.set(location, []);
                }

                groups.get(location).push(...formattedTimes);
            });

            return Array.from(groups, ([location, times]) => ({
                location,
                times: times.join(", "),
            }));
        },
    },
};
</script>
